import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { endooSpotManagementAuthModule } from '../Login/endooSpotManagementAuth.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { endooSpotRouterSettingsModule } from 'app/RouterManagement/RouterManagement.module';
import { endooSpotComponentsModule } from 'app/Components/endooSpotComponents.module';
import { MatMenuModule } from '@angular/material/menu';
import { ShortTermLoginService } from './ShortTermService/ShortTermLoginService';
import { ShortTermLoginListComponent } from './ShortTermList/ShortTermLoginList.component';
import { ShortTermLoginDetailDialogComponent } from './ShortTermList/ShortTermLoginDetailDialog.component';
import { NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
    imports: [
        CommonModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatDividerModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatPaginatorModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatExpansionModule,
        MatMenuModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        endooSpotManagementAuthModule,
        endooSpotRouterSettingsModule,
        endooSpotComponentsModule,
        NgxMatMomentModule,
        NgxMatDatetimePickerModule,
        MatDatepickerModule,
    ],
    declarations: [
        ShortTermLoginListComponent,
        ShortTermLoginDetailDialogComponent,
    ],
    providers: [
        ShortTermLoginService,
    ],
    exports: [
        ShortTermLoginListComponent,
        ShortTermLoginDetailDialogComponent,
    ],
})
export class endooSpotShortTermLoginModule { }
